interface Props<T extends string> {
	label: string
	value: T
	options: { value: T; label: string }[]
	onChange(value: T): void
}

export function Segmented<T extends string>({ label, value, options, onChange }: Props<T>) {
	return (
		<div className="segmented" role="group" aria-label={label}>
			{options.map((o) => (
				<button key={o.value} type="button" aria-pressed={o.value === value} onClick={() => onChange(o.value)}>
					{o.label}
				</button>
			))}
		</div>
	)
}
